import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LinkedInIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M18.4375 19.2331H15.235V14.215C15.235 13.0183 15.2107 11.4784 13.5662 11.4784C11.8965 11.4784 11.6415 12.7805 11.6415 14.1267V19.2331H8.43907V8.91393H11.5154V10.3205H11.5568C11.9866 9.50954 13.0319 8.65351 14.5934 8.65351C17.8382 8.65351 18.4384 10.7891 18.4384 13.5689V19.2331H18.4375ZM4.82213 7.50193C4.57783 7.50205 4.3359 7.45399 4.11019 7.3605C3.88448 7.26701 3.67943 7.12992 3.50677 6.95709C3.3341 6.78426 3.19722 6.57907 3.10394 6.35328C3.01067 6.12748 2.96284 5.8855 2.9632 5.6412C2.96338 5.27336 3.07263 4.91384 3.27714 4.60809C3.48165 4.30234 3.77223 4.0641 4.11214 3.9235C4.45204 3.7829 4.82601 3.74625 5.18675 3.81818C5.54749 3.89012 5.87879 4.06741 6.13877 4.32764C6.39874 4.58787 6.57571 4.91934 6.6473 5.28015C6.71889 5.64096 6.68188 6.01489 6.54095 6.35466C6.40001 6.69443 6.16149 6.98478 5.85555 7.18899C5.5496 7.39321 5.18997 7.50211 4.82213 7.50193ZM6.42786 19.2331H3.2164V8.91393H6.42786V19.2331ZM20.0396 0.804199H1.60888C0.726718 0.804199 0.0130615 1.50164 0.0130615 2.36217V20.8722C0.0130615 21.7336 0.726718 22.4301 1.60888 22.4301H20.0369C20.9181 22.4301 21.639 21.7336 21.639 20.8722V2.36217C21.639 1.50164 20.9181 0.804199 20.0369 0.804199H20.0396Z"
    />
  </svg>
);

LinkedInIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

LinkedInIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(22, 22),
};

export default LinkedInIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/linkedIn-v2.js